import apiClient from "services/axios";

const API = {
  list: "/api/v1/tag-groups",
  create: "/api/v1/tag-groups",
  detail: "/api/v1/tag-groups",
  update: "/api/v1/tag-groups",
  delete: "/api/v1/tag-groups",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const create = async (body) => {
  const response = await apiClient.post(API.create, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const duplicateDraft = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}/duplicate-draft`);
  if (response) {
    return response.data;
  }
  return false;
};

export const duplicate = async (id, body) => {
  const response = await apiClient.post(`${API.detail}/${id}/duplicate`, body);
  if (response) {
    return response.data;
  }
  return false;
};

const importFormData = (file, options) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("options", JSON.stringify(options));
  return formData;
};

export const previewTagGroupImport = async (file, options) =>
  (await apiClient.post(
    `${API.create}/import/preview`,
    importFormData(file, options),
    { headers: { "Content-Type": "multipart/form-data" }, propagateError: true }
  )).data;

export const importTagGroup = async (file, options) =>
  (await apiClient.post(
    `${API.create}/import`,
    importFormData(file, options),
    { headers: { "Content-Type": "multipart/form-data" }, propagateError: true }
  )).data;

export const update = async (id, body) => {
  const response = await apiClient.patch(`${API.update}/${id}`, body);
  if (response) {
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
